import { Grid, Header, Icon, List, SemanticICONS } from 'semantic-ui-react'
import { SamsungInternetIcon } from '../../atoms'

type ItemType = {
  name: string
  icon: SemanticICONS | 'samsung-internet'
}

const supportedDesktop: ItemType[] = [
  { name: 'Chrome 57+', icon: 'chrome' },
  { name: 'Firefox 52+', icon: 'firefox' },
  { name: 'Opera 44+', icon: 'opera' },
  { name: 'Safari 11+', icon: 'safari' },
  { name: 'Edge 16+', icon: 'edge' },
]

const supportedMobile: ItemType[] = [
  { name: 'Chrome 59+', icon: 'chrome' },
  { name: 'Firefox 55+', icon: 'firefox' },
  { name: 'Samsung Internet 7+', icon: 'samsung-internet' },
]

const SupportedBrowserGrid = () => {
  return (
    <Grid columns={2}>
      <Grid.Row style={{ paddingBottom: 0 }}>
        <Grid.Column>
          <Header as="h5" inverted>
            Desktop:
          </Header>
        </Grid.Column>
        <Grid.Column>
          <Header as="h5" inverted>
            Mobile - Android:
          </Header>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <List>
            {supportedDesktop.map(({ name, icon }) => {
              return (
                <List.Item>
                  {icon === 'samsung-internet' ? (
                    <SamsungInternetIcon size="large" />
                  ) : (
                    <Icon name={icon} size="large" />
                  )}
                  <div className="middle aligned content">{name}</div>
                </List.Item>
              )
            })}
          </List>
        </Grid.Column>
        <Grid.Column>
          <List>
            {supportedMobile.map(({ name, icon }) => {
              return (
                <List.Item>
                  {icon === 'samsung-internet' ? (
                    <SamsungInternetIcon size="large" />
                  ) : (
                    <Icon name={icon} size="large" />
                  )}
                  <div className="middle aligned content">{name}</div>
                </List.Item>
              )
            })}
          </List>
          <Header as="h5" inverted>
            Mobile iOS (11+)
          </Header>
          <List>
            <List.Item>
              <Icon name="safari" size="large" />
              <div className="middle aligned content">Safari 11+ but 11.2.2-11.2.6</div>
            </List.Item>
          </List>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}

export default SupportedBrowserGrid
